const _require = require('../lib/parser'),
  parser = _require.parser;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;
const calculate = (formula, variables) => {
  try {
    return parser.evaluate(formula, variables);
  } catch (err) {
    return undefined;
  }
};

/**
  * @function evalute - evaluate formulaBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  // a formula without variables is valid, but not vice versa
  const formula = source.formula;
  if (formula === undefined) {
    return undefined;
  }
  const processedFormula = await evaluateSource(formula, content, parentContentPath, transientContext, nativeFunctions);
  const result = calculate(processedFormula, transientContext);
  return result;
};
module.exports = {
  evaluate,
  calculate
};